import * as React from 'react'
import * as PropTypes from 'prop-types'
import styled, { css } from 'styled-components'
import { Link } from 'react-router-dom'
import { Fade } from 'react-reveal'

import media from '../../../services/generateMediaQueries'

import ZingIcon from '../../../assets/img/zing-icon.svg'

let LOADING = false

const StyledLink = styled(Link)`
  text-decoration: none;
`

const CardImage = styled.div.attrs(props => ({
  style: {
    background: `linear-gradient(rgba(141,122,157,0.40), rgba(141,122,157,0.40)), linear-gradient(180deg,rgba(0,0,0,0.00) 30%,#2C2F3A 100%), url('${props.logoImageUrl}'), linear-gradient(#000000, #000000)`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
  },
}))`
  position: absolute;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  transition: all 0.5s;
`

const StyledCard = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  width: 300px;
  height: 300px;
  margin: 0 0.625rem;
  border-radius: var(--border-radius-card);
  box-shadow: var(--box-shadow-large);
  overflow: hidden;
  background: linear-gradient(
      rgba(141, 122, 157, 0.4),
      rgba(141, 122, 157, 0.4)
    ),
    #f9f9f9;

  ${media.lessThan('large')`
    margin: 0 0.5rem;
    height: 309px;
  `}

  &:hover {
    ${CardImage} {
      transform: scale(1.2);
    }
  }

  ${() =>
    LOADING &&
    css`
      justify-content: center;
    `}
`

const CardWrapper = styled.div`
  outline: none;
`

const CardContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  flex: 1 1 auto;
  justify-content: flex-end;
  padding: 2.5625rem 2.75rem;
  height: 100%;
  border-radius: var(--border-radius-card);
  color: #ffffff;
  text-align: center;
  min-width: 0;
  z-index: 1;
`

const Title = styled.h1`
  font-size: 1.25rem;
  line-height: 1.6875rem;
  font-weight: var(--font-weight-bold);
  width: 100%;
  margin: 0;
  margin-bottom: 1.875rem;
`

const Schedule = styled.span`
  font-size: 0.6875rem;
  line-height: 1rem;
  font-weight: var(--font-weight-boldest);
  letter-spacing: 0.46px;
  background: rgba(255, 255, 255, 0.2);
  border-radius: var(--border-radius-small);
  max-width: 100%;
  margin: 0 auto;
  padding: 7px 16px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  text-align: left;
  text-transform: uppercase;
`

const Text = styled.p`
  margin: 0;
  color: #ffffff;
  font-weight: 500;
  text-align: center;
`

const ZingIconComponent = styled.img.attrs({ src: ZingIcon })`
  margin-bottom: 1rem;
`

function EventsCard(props) {
  const {
    logoImageUrl = '',
    subtitle = '',
    title = '',
    link = '',
    id = 0,
    onClick,
    onRetry,
    loading = false,
    error = false,
  } = props

  LOADING = loading

  const CardComponent = () => (
    <CardWrapper>
      <StyledLink
        to={link}
        onClick={
          error
            ? e => {
                e.preventDefault()
                onRetry()
              }
            : onClick
        }
      >
        <StyledCard>
          {!LOADING ? (
            <>
              <CardImage logoImageUrl={logoImageUrl} />
              <CardContent>
                <Title>{title}</Title>
                {!!subtitle && <Schedule>{subtitle}</Schedule>}
              </CardContent>
            </>
          ) : (
            <>
              <ZingIconComponent />
              {error && (
                <>
                  <Text>Failed to load What's On.</Text>
                  <Text>Tap to retry.</Text>
                </>
              )}
            </>
          )}
        </StyledCard>
      </StyledLink>
    </CardWrapper>
  )

  if (LOADING) {
    return <CardComponent />
  }

  return (
    <Fade right distance="1rem" delay={300 + 50 * id} duration={300} force>
      <CardComponent />
    </Fade>
  )
}

EventsCard.defaultProps = {
  link: '',
}

EventsCard.propTypes = {
  logoImageUrl: PropTypes.string,
  subtitle: PropTypes.string,
  title: PropTypes.string,
  link: PropTypes.string,
  onClick: PropTypes.func,
  onRetry: PropTypes.func,
  loading: PropTypes.bool,
  error: PropTypes.bool,
}

export default EventsCard
